import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/components/common/api';
import { KontableComponent } from './../../../../../../modules/UIKit/components/kontable/kontable.component';
import { MgChildCard } from './../../../../../../models/mg-child-card.model';
import { CustomerCardService } from './../../../../../../services/customer/customer-card.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Card } from './../../../../../../models/loyalty-card.model';
import { Component, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-mg-link-card',
  templateUrl: './mg-link-card.component.html',
  styleUrls: ['./mg-link-card.component.css']
})
export class MgLinkCardComponent implements OnInit {
  parentCardNumber: string;
  customerId: string;
  selectedChildCardNumber: string;
  showChildCardSelectionDialog = false;
  childCards: MgChildCard[];
  switchValue = true;
  dateFilter = KontableComponent.DateFilter;
  isChild = false;
  @ViewChild('childCardsTable') childCardsTable: KontableComponent;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private customerCardService: CustomerCardService,
    private messageService: MessageService,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    this.parentCardNumber = this.activatedRoute.snapshot.params['cardNumber'];
    this.customerId = this.activatedRoute.snapshot.params['customerId'];
    this.getChildCards();
  }

  getChildCards(all = false) {
    this.childCards = [];
    this.customerCardService.getKloyChildCards(this.parentCardNumber).subscribe(res => {
      if (all && res && res.length > 0) {
        // Se si vuole visualizzare tutto
        this.childCards = res;
      } else if (res && res.length > 0 && res.filter(card => card.cartaCollegata === this.parentCardNumber).length > 0) {
        // Se la carta di partenza è una carta figlia
        this.isChild = true;
        this.childCards = res;
      } else if (res && res.length > 0) {
        // Creo un nuovo oggetto con le carte raggruppate in array per "cartaCollegata"
        const groupedCards = res.reduce((group, card) => {
          // Se proprietà già esiste resta uguale, altrimenti setto come array vuoto
          if (card.blackList === '0' || card.blackList === '1') {
            group[card.cartaCollegata] = group[card.cartaCollegata] || [];
            group[card.cartaCollegata].push(card);
          }
          return group;
        }, {});
        // Ordino ogni gruppo per "dataCollegamento"
        for (let group in groupedCards) {
          if (groupedCards[group].length > 1) {
            groupedCards[group].sort((a, b) => new Date(b.dataCollegamento).getTime() - new Date(a.dataCollegamento).getTime());
          }
          // Pusho in "childCards" la prima carta di ogni gruppo
          this.childCards.push(groupedCards[group][0]);
        }
      }
      this.childCardsTable.refresh();
    });
  }

  openSelectChildCardDialog() {
    this.showChildCardSelectionDialog = true;
  }

  onChildCardSelected(card: Card) {
    this.selectedChildCardNumber = card.card_no;
    this.showChildCardSelectionDialog = false;
  }

  linkCard() {
    this.customerCardService.linkKloyCard(this.parentCardNumber, this.selectedChildCardNumber).subscribe(() => {
      this.messageService.add({
        severity: 'success',
        summary:  this.translateService.instant('common.success'),
        detail:  this.translateService.instant('common.operation_success')
      });
      this.getChildCards();
    });
  }

  unlinkCard(card: MgChildCard) {
    this.customerCardService.unlinkKloyCard(card.cartaMaster, card.cartaCollegata).subscribe(() => {
      this.messageService.add({
        severity: 'success',
        summary:  this.translateService.instant('common.success'),
        detail:  this.translateService.instant('common.operation_success')
      });
      this.getChildCards();
    });
  }

  backToCustomer() {
    this.router.navigate([`customers-details/${this.customerId}`])
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/loyaltyinfo/components/mg-link-card/mg-link-card.component.ts